import React, { FC } from 'react';

import Typography from 'src/common/components/Typography';
import type { TypographyProps } from 'src/common/components/Typography';

import styles from './Modal.module.scss';

type HeaderProps = {
  /**
   * Custom, auxiliary content.
   */
  children?: React.ReactNode;
  /**
   * The text paragraph to accompany the title.
   */
  description?: React.ReactNode;
  /**
   * The preset size of the description.
   */
  descriptionsSize?: Extract<TypographyProps['size'], 'body-s' | 'body-m'>;
  /**
   * The main title heading of the modal content.
   */
  title?: React.ReactNode;
  /**
   * The preset size of the title.
   */
  titleSize?: Extract<TypographyProps['size'], 'heading-3' | 'heading-4' | 'heading-5'>;
};

const Header: FC<HeaderProps> = ({
  children,
  description,
  descriptionsSize = 'body-s',
  title,
  titleSize = 'heading-5',
}) => (
  <header className={styles.header}>
    {title && (
      <div className={styles.title}>
        <Typography
          size={titleSize}
          weight="semibold"
          type="h3"
        >
          {title}
        </Typography>
      </div>
    )}
    {description && (
      <Typography
        className={styles.description}
        size={descriptionsSize}
        type="p"
      >
        {description}
      </Typography>
    )}
    {children}
  </header>
);

export default Header;
